import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LogoSsurfaceIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.8496 13.4912L21.5124 4.75265C21.2128 3.61284 20.3339 2.73299 19.1953 2.43304L10.4861 0.113436C9.36747 -0.186513 8.14898 0.113436 7.33 0.953293L0.957879 7.33221C0.138893 8.17206 -0.200687 9.37186 0.118917 10.4917L2.45603 19.2302C2.75565 20.35 3.63457 21.2298 4.77316 21.5498L13.5024 23.8894C14.621 24.1893 15.8395 23.8694 16.6585 23.0495L23.0505 16.6506C23.8695 15.8308 24.1891 14.631 23.8895 13.4912H23.8496ZM14.0017 12.5313C13.3625 14.9509 13.4824 17.5905 13.4824 17.5905C13.4824 17.5905 12.2839 15.2509 10.5061 13.4712C8.72826 11.6915 6.39116 10.4917 6.39116 10.4917C6.39116 10.4917 9.02789 10.6116 11.4449 9.97176C13.8619 9.33187 16.0792 7.89211 16.0792 7.89211C16.0792 7.89211 14.6609 10.1117 14.0017 12.5313Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

LogoSsurfaceIcon.displayName = 'LogoSsurfaceIcon';
